var map = {
	"./brown.png": 8133,
	"./dark.png": 1709,
	"./orange.png": 5352,
	"./pink.png": 8749,
	"./purple.png": 1032,
	"./red.png": 1604,
	"./white-milk.png": 9007,
	"./white.png": 6054,
	"./yellow.png": 1398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4103;